module.exports = __webpack_public_path__ + "static/img/addressPic.b8ad2b1c.jpg";